import { useState } from 'react'
import { useGetMonitoringSessionsQuery } from '../services/sessionMonitoringApi'
import MonitoringSessionList from './MonitoringSessionList'
import './DailyMonitoringSessions.css'

export default function DailyMonitoringSessions({ projectId, runId }: { projectId: string; runId: string }) {
  const [page, setPage] = useState(0)
  const query = useGetMonitoringSessionsQuery({ projectId, runId, page }, {
    pollingInterval: 10_000,
    skipPollingIfUnfocused: true,
  })
  const data = query.currentData
  return <section className="daily-monitoring-sessions" aria-labelledby="daily-monitoring-sessions-title">
    <header>
      <h2 id="daily-monitoring-sessions-title" className="run-detail__section-title">User sessions{data && <> · {data.total.toLocaleString()}</>}</h2>
      <p>Sessions received during this monitoring day, including sessions not yet reviewed. Completed reviews with no observations are shown explicitly.</p>
    </header>
    {query.isFetching && !data && <p role="status">Loading user sessions…</p>}
    {query.isError && <p role="alert">Could not load user sessions. <button type="button" onClick={() => void query.refetch()}>Retry</button></p>}
    {data && data.sessions.length === 0 && <p>No user sessions were received during this monitoring day.</p>}
    {data && <MonitoringSessionList projectId={projectId} runId={runId} sessions={data.sessions} canEdit={data.can_edit} onRefresh={query.refetch} />}
    <nav className="daily-monitoring-sessions__pagination" aria-label="User session pages">
      <button type="button" disabled={page === 0 || query.isFetching} onClick={() => setPage(value => value - 1)}>Previous</button>
      <span>Page {page + 1}</span>
      <button type="button" disabled={!data?.has_more || query.isFetching} onClick={() => setPage(value => value + 1)}>Next</button>
    </nav>
  </section>
}
